import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import MenuGroup from "aldoo-ra/MenuGroup"

const ArticleBanner = () => {
  return (
    <CMSRender
      contentType="BannerCTA"
      match={{ "content.id": "ArticleBannerCTA" }}
      renderItem={(data) => (
        <div className="relative w-full h-auto md:h-[154px] flex flex-col md:flex-row items-center justify-center md:justify-evenly gap-3 rounded-[24px] overflow-hidden p-4 sm:p-6">
          <Typography
            variant="h5"
            className="relative text-white text-center my-0 z-10"
          >
            {data.text}
          </Typography>

          <MenuGroup
            name="TryNow"
            renderAs="hlist"
            itemsAsLinks={false}
            styleOverrides={{
              menu: "flex flex-row items-center gap-0 my-0",
              menu_item: "flex items-center list-none px-0 py-0 my-0 rounded-md text-admin_text",
            }}
            menuItemRender={(item) => {
              if (!item) return null

              const url = item?.link && item?.link[0]?.url

              return (
                <Button
                  variant="primary_xl"
                  className="z-10 whitespace-nowrap my-0"
                >
                  <a href={url}>
                    {item?.label}
                  </a>
                </Button>
              )
            }}
          />

          <img
            src={data.image}
            alt={data.label}
            className="absolute left-0 md:h-[154px] w-auto object-cover z-0"
            style={{
              height: "154px",
              width: "auto",
              maxHeight: "none",
              maxWidth: "none",
            }}
          />
        </div>
      )}
    />
  )
}

export default ArticleBanner